import styled from "styled-components"

export const DayHeaderContentWrapper = styled.div<{ $isWeekEnd: boolean }>`
	color: ${(props) => (props.$isWeekEnd ? "#5B3FFF" : "#969696")};
	font-size: 16px;
	font-weight: 700;
	line-height: 19.2px;
	padding-block: 12px;
`
